import * as React from "react"
import { DrawerSeeker } from "@ui-seeker/core"

import AdminBrandsCreateDrawerContent from "./Content/CreateDrawer"
import AdminBrandsUpdateDrawerContent from "./Content/UpdateDrawer"
import { useAdminBrandModal } from "../@hooks"


export default function AdminBrandsForm() {
    const { isOpen, isCreate, handleClose, handleSend } = useAdminBrandModal()

    return <DrawerSeeker
        title={isCreate ? 'Create Brand' : 'Edit Brand'}
        isOpen={isOpen}
        controller={handleClose}
        successProps={{ onClick: handleSend }}
        width={isCreate ? "50%" : ""}
    >
        {isCreate ? <AdminBrandsCreateDrawerContent /> : <AdminBrandsUpdateDrawerContent/>}
    </DrawerSeeker>
}